<template>
  <div id="Liangmianshujutongji">
    <div class="tr-header">
      <p class="title">两面数据统计</p>
    </div>
    <div class="tr-table-container">
      <div v-if="betType != 'ks'" class="check_box_one">
        <div v-if="dataSource.length > 0">
          <span
            :class="{'checked_button': ballIndex == i}"
            class="handle"
            v-if="Number(i)"
            v-for="(it,i) in dataSource[0]"
            :key="i"
            @click="handleBallChecked(i)"
          >第{{i}}球</span>
        </div>
      </div>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
      <span class="food_span">*以每10期为一组，统计最近20组中单双大小的出现次数。</span>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Liangmianshujutongji",
  data() {
    return {
      columns: [],
      pageSize: 30,
      dataSource: [],
      ballIndex: 1
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // this.reset();
        this.getDate();
      }
    }
  },
  methods: {
    reset(data) {
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
      // this.lostColumns = columns(this.betType, data).lostList(this);
    },
    async getDate() {
      // /queryKcReportByIssue.do?gameType=CQSSC
      let req = {
        gameType: this.$route.params.gameType
        // pageSize: 30,
        // startRow: 0
      };
      let res = await this.$http.post("/queryKcTwoPartReport.do", req);
      if (res.data.returnCode == "0000") {
        console.log(res.data.returnList, "res.data");

        var arr = res.data.returnList;
        // var arr = format.formatJson(res.data.returnList);
        this.reset(arr);
        this.dataSource = arr;
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    handleBallChecked(i) {
      this.ballIndex = i;
      this.getDate();
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
/deep/.ivu-table-wrapper {
  min-width: 1160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Liangmianshujutongji/index.vue